import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { schools } from '../../data/mockSchools';
import { cases } from '../../data/mockCases';
import { articles } from '../../data/mockArticles';
function SectionHeader({
  title,
  onMore
}: {
  title: string;
  onMore?: () => void;
}) {
  return <div className="flex items-center justify-between px-4 pt-3 pb-2" data-id="element-107">
      <div className="font-bold text-slate-800 flex items-center gap-2" data-id="element-108">
        <span className="w-1 h-4 bg-blue-500 rounded" data-id="element-109" /> {title}
      </div>
      <button onClick={onMore} className="text-xs text-slate-400 flex items-center" data-id="element-110">
        查看更多 <ChevronRightIcon size={12} data-id="element-111" />
      </button>
    </div>;
}
export function RecommendSections() {
  const nav = useNavigate();
  const hot = schools.slice(0, 6);
  const recentCases = cases;
  const articlesList = articles.slice(0, 4);
  return <div className="mt-3 space-y-3" data-id="element-112">
      {/* 热门院校 */}
      <div className="bg-white rounded-2xl mx-3 overflow-hidden" data-id="element-113">
        <SectionHeader title="热门院校" onMore={() => nav('/schools')} data-id="element-114" />
        <div className="px-3 pb-3 flex gap-3 overflow-x-auto no-scrollbar" data-id="element-115">
          {hot.map(s => <button key={s.id} onClick={() => nav(`/schools/${s.id}`)} className="shrink-0 w-32 bg-slate-50 rounded-xl p-3 text-left active:bg-slate-100" data-id="element-116">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center text-[10px] font-bold border border-slate-100 mb-2" style={{
            background: s.logoBg,
            color: s.logoColor
          }} data-id="element-117">
                {s.logoText}
              </div>
              <div className="text-sm font-bold text-slate-800 truncate" data-id="element-118">
                {s.cn}
              </div>
              <div className="text-[10px] text-slate-500 mt-0.5" data-id="element-119">
                {s.flag} {s.country}
              </div>
              <div className="text-[10px] text-amber-600 font-semibold mt-1" data-id="element-120">
                QS #{s.rank}
              </div>
            </button>)}
        </div>
      </div>

      {/* 最新录取案例 */}
      <div className="bg-white rounded-2xl mx-3 overflow-hidden" data-id="element-121">
        <SectionHeader title="最新录取案例" onMore={() => nav('/community')} data-id="element-122" />
        <div className="divide-y divide-slate-100" data-id="element-123">
          {recentCases.map(c => <button key={c.id} onClick={() => nav(`/community/cases/${c.id}`)} className="w-full flex gap-3 p-3 active:bg-slate-50 text-left" data-id="element-124">
              <img src={c.avatar} alt="" className="w-12 h-12 rounded-full object-cover bg-slate-100 shrink-0" data-id="element-125" />
              <div className="flex-1 min-w-0" data-id="element-126">
                <div className="text-sm font-bold text-slate-800" data-id="element-127">
                  {c.name} · {c.major}
                </div>
                <div className="text-[11px] text-slate-500 mt-0.5" data-id="element-128">
                  {c.bgSchool} · {c.bgGpa} · {c.bgLang}
                </div>
                <div className="flex flex-wrap gap-1 mt-1.5" data-id="element-129">
                  {c.offers.map(o => <span key={o} className="text-[10px] bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded" data-id="element-130">
                      🎓 {o}
                    </span>)}
                </div>
              </div>
            </button>)}
        </div>
        
      </div>

      {/* 留学干货 */}
      <div className="bg-white rounded-2xl mx-3 overflow-hidden" data-id="element-131">
        <SectionHeader title="留学干货" data-id="element-132" />
        <div className="divide-y divide-slate-100" data-id="element-133">
          {articlesList.map(a => <div key={a.id} className="flex gap-3 p-3" data-id="element-134">
              <img src={a.cover} alt="" className="w-20 h-16 rounded-lg object-cover bg-slate-100 shrink-0" onError={e => {
            e.currentTarget.src = 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=600&auto=format&fit=crop';
          }} data-id="element-135" />
              <div className="flex-1 min-w-0 flex flex-col justify-between" data-id="element-136">
                <div className="text-sm font-medium text-slate-800 line-clamp-2" data-id="element-137">
                  {a.title}
                </div>
                <div className="flex items-center justify-between text-[11px] text-slate-400 mt-1" data-id="element-138">
                  <span className="bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded" data-id="element-139">
                    {a.tag}
                  </span>
                  <span data-id="element-140">{a.meta}</span>
                </div>
              </div>
            </div>)}
        </div>
        
      </div>
    </div>;
}